<template>
    <div>
        <InputOption :isDetails="isDetails" class="input-option" v-for="(k,input) in optionsArr" :key="k" v-bind="input.props" v-model="input.value"></InputOption>
    </div>
</template>
<script>
    import InputOption from './InputOption.vue'
    export default {
        name: 'InputOptions',
        props: {
            // value: String,
            // placeholder:{
            //     type: String,
            //     default:''
            // },
            // rightText:{
            //     type: String,
            //     default:''
            // },
            // leftText:{
            //     type: String,
            //     default:''
            // },
            optionsArr:Array,
            isDetails:{
                type:Boolean,
                default:false
            }
        },
        methods:{

        },
        components:{InputOption}
    }
</script>
<style lang="scss" scoped>
    .input-option{
        display: flex;
        align-items: center;
        width: 100%;
        height: 45px;
        margin-bottom: 10px;
        position: relative;
    }

</style>
